$(document).on 'turbo:load', ->
  new App.lessonsAll() if $(".lessonsShowView, .lessonActivitiesIndexView").length

class @App.lessonsAll
  constructor: ->
    @loadCarousel()
    @checkForFeedback()
    @panelScrollCheck()
    @bindElements()
    @bindLogView()
    @bindLessonToolbar()
    @$videoContainer = $(".videoContainer")
    new CollapsibleBehavior()

  loadCarousel: ->
    if $(".carouselContainer.review").length
      $(".carouselContainer.review").carouFredSel
        auto: false
        circular: false
        infinite: false
        items:
          visible: 1
        scroll:
          items: 1
          fx: "scroll"
          duration: 350
          easing: "easeOutQuart"
          onAfter: (data) ->
            # @panelScrollCheck() # I'm not sure what this does?
            if $(this).triggerHandler("currentVisible").hasClass("hasFeedback")
              $(this).triggerHandler("currentVisible").find(".mark-feedback-read-trigger").click()

            $el = $(".panel.review")
            url  = $el.data('url')
            currentPanel = $el.find(".uiCycleNav").find(".selected").index() + 1
            history.pushState(null , null, url+'#question-'+currentPanel)

        prev:
          button: ".panel.review .actionLeft"
          key: null
        next:
          button: ".panel.review .actionRight"
          key: null
        pagination: ".panel.review .topNav .uiCycleNav"
      ,
        debug: false
      if $(".carouselContainer.review").triggerHandler("currentVisible").hasClass("hasFeedback")
        $(".carouselContainer.review").triggerHandler("currentVisible").find(".mark-feedback-read-trigger").click()

  checkForFeedback: ->
    carousel = $(".carouselContainer.review")
    nav = $(".uiCycleNav")
    $(".uiCycleNav").find("a").each ->
      index = $(this).index()
      item = carousel.find("*[data-position=\"" + index + "\"]")
      if item.hasClass("hasFeedback")
        $(this).addClass('hasFeedback')
        $(this).addClass(item.attr('id'))

  panelScrollCheck: ->
    $el = $(".panel.review")
    $next = $el.find(".actionRight")
    $prev = $el.find(".actionLeft")
    panelOrigin = 1
    currentPanel = $el.find(".uiCycleNav").find(".selected").index() + 1
    panelCount = $el.find(".item").length
    if currentPanel is panelOrigin
      $prev.fadeOut "300"
      $next.fadeIn "300", "easeOutQuart"
    else if currentPanel is panelCount
      $prev.fadeIn "300", "easeOutQuart"
      $next.fadeOut "300"
    else
      $prev.fadeIn "300", "easeOutQuart"
      $next.fadeIn "300", "easeOutQuart"

  ###
  General binding of event to els on page.
  ###
  bindElements: ->
    self = this

    # Live events for elements in panels
    $("#panels").on "click.lessonsAll", ".nextQ a", (e) ->
      $panel = $(this).parents(".panel")
      e.preventDefault()
      $panel.find("button.actionRight").click()
      $panel.find(".flashMessages").hide().find(".flash").hide()

    $("#panels").on "click.lessonsAll", ".nextS a", (e) ->
      $panel = $(this).parents(".panel")
      e.preventDefault()
      self.nextPanel()
      $panel.find(".flashMessages, .flash").hide()

    $("#panels").on "click.lessonsAll", "button.try, .uiCycleNav a", (e) ->
      $panel = $(this).parents(".panel")
      e.preventDefault()
      $panel.find(".flashMessages").hide().find(".flash").hide()

    $("#panels").on "click.lessonsAll", "div.a label", (e) ->
      $(this).parents(".as").find(".selected").removeClass("selected").end().end().parents(".a").addClass "selected"

  bindLessonToolbar: ->
    $(".nav-toolbar .share-lesson").on "click", (e) =>
      targetUrl      = $(e.currentTarget).attr('data-url')
      method         = $(e.currentTarget).attr('data-method')
      confirmMessage = $(e.currentTarget).attr('data-confirm')

      return if targetUrl == '#'

      if (typeof(confirmMessage) == 'undefined' || confirm(confirmMessage))
        $.ajax
          type: method
          url: targetUrl
          dataType: 'script'

      return false

  ###
  Event Handler to shift to the next panel
  @param  {Object} e Event (jquery) object.
  @param  {String} [caller] A string telling who is calling this event.
  @return {Boolean}
  ###
  nextPanel: (e, caller) ->
    $next = $('.uiToggleSwitch .active').parents('li').next('li').children('a')
    return false if caller is "videoState" and @$videoContainer.is(".isRight")
    $next.click()

  bindLogView: ->
    $(".uiToggleSwitch").click =>
      @logView()

  logView: ->
    # only log views on the lesson/show page
    return  if $(".lessonsShowView").length is 0

    # only log views once
    return  if $(document.body).data("viewLogged") is true

    split_path = window.location.pathname.split('/')
    path_prefix = split_path[1] # This could be 'on' or 'lessons'
    lesson_id = split_path[2]
    url = '/lesson_views?lesson_id=' + lesson_id
    $.ajax {
      type: "POST"
      url: url
      dataType: "script"
      beforeSend: (xhr) ->
        xhr.setRequestHeader "X-CSRF-Token",
                              $("meta[name=\"csrf-token\"]").attr("content")
    }

    # let's only do this once
    $(document.body).data "viewLogged", true

  logEnded: ->
    # only log ended on the lesson/show page
    return if $(".lessonsShowView").length is 0

    # only log ended once
    return if $(document.body).data("endedLogged") is true

    split_path = window.location.pathname.split('/')
    path_prefix = split_path[1] # This could be 'on' or 'lessons'
    lesson_id = split_path[2]
    return if lesson_id is undefined

    url = '/lesson_activities/completed?lesson_id=' + lesson_id
    $.ajax {
      type: "POST"
      url: url
      dataType: "script"
      beforeSend: (xhr) ->
        xhr.setRequestHeader "X-CSRF-Token",
                              $("meta[name=\"csrf-token\"]").attr("content")
    }

    # let's only do this once
    $(document.body).data "endedLogged", true
